import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, Fragment } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {
    Button,
    Divider,
    ListItem,
    ListItemText,
    List,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Grid,
} from '@material-ui/core';

import {
    DialogContentText,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

import Box from '@material-ui/core/Box';

import {
    member as v_member,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../request/values';

import ToastStr from '../request/toastStr';
import { useSnackbar } from 'notistack';

import { COLORS } from './Theme';
import axios from 'axios';
import { SIcon } from './Icon';
import { DialogConfirm, DialogInput } from './Dialog';
import { useHistory } from 'react-router-dom';
import { TitleBackBar } from './header/TitleBar';
import NumberFormat from 'react-number-format';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    listWrapper: {
        padding: '0 15px',
        [theme.breakpoints.up('md')]: {
            padding: '0 25px',
        },
    },
    CompanyAsset: {
        borderRadius: 12,
        margin: 'auto',
        marginBottom: '1.5vh',
        marginTop: '4vh',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        // width: '82vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        color: `${COLORS.PUMPKIN}`,
        [theme.breakpoints.up('md')]: {
            padding: '2.2vh 50px',
        },
    },
    companyName: {
        alignSelf: 'center',
        ...theme.typography.h4,
        color: `${COLORS.WATER_BLUE}`,
        fontWeight: 'bold',
        marginBottom: '3vh',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h2,
            color: `${COLORS.WATER_BLUE}`,
            fontWeight: 'bold',
        },
    },
    assetInfo: {
        ...theme.typography.subtitle1,
        color: `${COLORS.PUMPKIN}`,
        fontFamily: 'NanumR',
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h4,
            color: `${COLORS.PUMPKIN}`,
            fontFamily: 'NanumR',
            fontWeight: 'normal',
        },
    },
    capital: {
        ...theme.typography.h4,
        alignSelf: 'center',
        marginTop: '4vh',
        color: `${COLORS.WATER_BLUE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h3,
            color: `${COLORS.WATER_BLUE}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
}));

const CompanyAsset: React.FC<any> = (props) => {
    const classes = useStyles();

    const { member } = props;
    let history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [asset, setAsset] = useState({
        company_name: '',
        stock: 0,
        loan: 0,
        loan_interest: 0,
        capital: 0,
        license_stock: 0,
        material_stock: 0,
        material_loan_stock: 0,
    });

    const getCompanyAsset = () => {
        let url = new URL(SERVER + v_member.member + v_member.company_asset);
        let params = {
            companyNum: member.companyNum,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data) => {
                console.log(data.asset);
                if (data.code === Values.SUCCESS_CODE) {
                    setAsset(data.asset);
                }
            });
    };

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    };

    useEffect(() => {
        getCompanyAsset();
        console.log(asset);
    }, []);
    return (
        <div className="content">
            <TitleBackBar
                history={history}
                title="재무현황"
                titleIcon="price"
            />
            <Box className={classes.listWrapper}>
                <ListItem className={classes.CompanyAsset}>
                    <Typography className={classes.companyName}>
                        {asset.company_name}
                    </Typography>
                    <Typography className={classes.assetInfo}>
                        <span>현금 자산 : </span>
                        <NumberFormat
                            value={asset.stock}
                            displayType={'text'}
                            thousandSeparator={true}
                        />
                        <span>원</span>
                    </Typography>
                    <Typography className={classes.assetInfo}>
                        <span>재고 자산 : </span>
                        <NumberFormat
                            value={asset.material_stock}
                            displayType={'text'}
                            thousandSeparator={true}
                        />
                        <span>원</span>
                    </Typography>
                    {member.companyType === 'M' ? (
                        <Typography className={classes.assetInfo}>
                            <span>지식 재산권 : </span>
                            <NumberFormat
                                value={asset.license_stock}
                                displayType={'text'}
                                thousandSeparator={true}
                            />
                            <span>원</span>
                        </Typography>
                    ) : (
                        <Typography className={classes.assetInfo}>
                            <span>판매한 재료 : -</span>
                            <NumberFormat
                                value={asset.material_loan_stock}
                                displayType={'text'}
                                thousandSeparator={true}
                            />
                            <span>원</span>
                        </Typography>
                    )}
                    <Typography className={classes.assetInfo}>
                        <span>대출금 : </span>
                        <NumberFormat
                            value={asset.loan}
                            displayType={'text'}
                            thousandSeparator={true}
                        />
                        <span>원</span>
                    </Typography>
                    <Typography className={classes.assetInfo}>
                        <span>대출 이자 : </span>
                        <NumberFormat
                            value={asset.loan_interest}
                            displayType={'text'}
                            thousandSeparator={true}
                        />
                        <span>원</span>
                    </Typography>
                    <Typography className={classes.capital}>
                        <span>자본 통계 : </span>
                        <NumberFormat
                            value={asset.capital + asset.license_stock}
                            displayType={'text'}
                            thousandSeparator={true}
                        />
                        <span>원</span>
                    </Typography>
                </ListItem>
            </Box>
        </div>
    );
};

export default CompanyAsset;
